import React, { useEffect, useState } from "react";
import { Alert, Card, Spin, message } from "antd";
import { useTranslation } from "react-i18next";
import { errorText } from "../api";
import { formatDate } from "../shared/money";
import Amount from "../shared/Amount";
import ResponsiveTable from "../../../../design-system/ResponsiveTable";
import { listCostRates } from "./api";

const CostRates = () => {
  const { t } = useTranslation("accounting");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    listCostRates()
      .then(res => setData(res.data))
      .catch(err => message.error(errorText(err)))
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    { title: t("Employee"), dataIndex: ["employee", "name"], mobile: "title" },
    {
      title: t("Weekly hours"),
      dataIndex: "weeklyHours",
      align: "end",
      render: v => <span className="acct-num">{v}</span>
    },
    {
      title: t("Productive hours / year"),
      dataIndex: "annualProductiveHours",
      align: "end",
      render: v => <span className="acct-num">{v}</span>
    },
    {
      title: t("Stundenkostensatz"),
      dataIndex: "costRatePerHour",
      align: "end",
      mobile: "subtitle",
      render: v => (v ? <Amount cents={v} large /> : "—")
    },
    { title: t("Updated"), dataIndex: "updatedAt", render: v => (v ? formatDate(v) : "—") }
  ];

  return (
    <Spin spinning={loading}>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message={t("Arbeitgeberkosten je produktiver Stunde")}
        description={t(
          "Recalculated after every approved Lohnlauf: employer cost of the month × 12 divided by the productive hours of the year (weekly hours × 52 minus public holidays, {{vacation}} vacation days and {{sick}} sick days). Used by the Nachkalkulation of projects.",
          {
            vacation: data?.assumptions?.vacationDays ?? 30,
            sick: data?.assumptions?.sickDays ?? 10
          }
        )}
      />
      <Card size="small">
        <ResponsiveTable
          rowKey={r => r.employee.id}
          size="small"
          pagination={false}
          dataSource={data?.rows || []}
          columns={columns}
        />
      </Card>
    </Spin>
  );
};

export default CostRates;
